import { useEffect, useSyncExternalStore } from 'react';

export type Platform = 'unknown' | 'ios' | 'android' | 'ie';

export function getPlatform(userAgent?: string): Platform {
  if (!userAgent) {
    return 'unknown';
  }

  if (userAgent.includes('iPhone') || userAgent.includes('iPad')) {
    return 'ios';
  }

  if (userAgent.includes('Android')) {
    return 'android';
  }

  if (userAgent.includes('Trident')) {
    return 'ie';
  }

  return 'unknown';
}

let currentPlatform: Platform = 'unknown';
let initialized = false;
const listeners = new Set<() => void>();

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

function emitPlatform(nextPlatform: Platform) {
  if (currentPlatform === nextPlatform) {
    return;
  }

  currentPlatform = nextPlatform;
  listeners.forEach((listener) => listener());
}

export default function usePlatform(): Platform {
  useEffect(() => {
    if (initialized) {
      return;
    }

    initialized = true;
    emitPlatform(getPlatform(window.navigator.userAgent));
  }, []);

  return useSyncExternalStore(
    subscribe,
    () => currentPlatform,
    () => 'unknown',
  );
}
